module.exports = __webpack_public_path__ + "img/logo_jawapos1.b52fd012.png";